import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

export default function LatestUpdates() {
  const latest = [...mangaList].sort(() => Math.random() - 0.5).slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>最新更新</h2>
            <p className="text-sm text-foreground-500 mt-1">刚刚更新的漫画章节，快来看看吧</p>
          </div>
          <Link to="/category/action" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1">
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {latest.map((manga) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="flex items-center gap-4 p-3 md:p-4 bg-background-100 hover:bg-primary-50 rounded-xl transition-colors group"
            >
              <div className="w-12 h-16 md:w-14 md:h-20 rounded-md overflow-hidden bg-background-200 flex-shrink-0">
                <img src={manga.coverImage} alt={manga.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{manga.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">
                  <span className="text-primary-500">{manga.chapters[manga.chapters.length - 1]?.title}</span>
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                <span className="text-xs text-foreground-500">{manga.author}</span>
                <p className="text-xs text-foreground-400 mt-1">更新于 {manga.updateTime}</p>
              </div>
              <span className="hidden sm:flex w-8 h-8 items-center justify-center text-foreground-400 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}